import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  extends: [],
  server: {
    GITHUB_APP_ID: z.string(),
    GITHUB_WEBHOOK_SECRET: z.string(),
    GITHUB_APP_PRIVATE_KEY_BASE64: z
      .string()
      .transform((v) => Buffer.from(v, "base64").toString("utf-8")),
    AUTH_GITHUB_SECRET: z.string(),
  },
  client: {},
  experimental__runtimeEnv: {},
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
